<template>
    <v-chip :color="color" readonly dark :outlined="outlined" small >
        <v-icon size="15" class="mr-2">{{icon}}</v-icon>
        {{eventStatus.name}}
    </v-chip>
</template>

<script>
    import {getStatusColor, getStatusIcon} from '@/utils/ScheduleEvent'
    export default{
        props: {
          eventStatus: {
            type: Object
          },
          outlined: {
            type: Boolean,
            default: true
          }
        },
        computed: {
            color(){
                return getStatusColor(this.eventStatus.id)
            },
            icon(){
                return getStatusIcon(this.eventStatus.id)
            }
        }
    }
</script>
